export default "__VITE_ASSET__9fa11198__"